import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Login from './Login';
import WebsiteNavbar from './Website/WebsiteNavbar';
import WebsiteHome from './Website/WebsiteHome';
import CertificateSelection from './Website/CertificateSelection';
import Birthcertificate from './Website/Birthcertificate';
import Deathcertificate from './Website/Deathcertificate';
import Requestmarriage from './Website/Requestmarriage';
import Properstandard from './Website/Properstandard';
import Demandcertificate from './Website/Demandcertificate';
import Certificatedestitute from './Website/Certificatedestitute';
import Housetax from './Website/Housetax';
import Paywatertax from './Website/Paywatertax';
import Womengroup from './Website/Womengroup';
import GramPanchayatInfo from './Website/GramPanchayatInfo';
import GramPanchayatSamiti from './Website/GramPanchayatSamiti';
import WebsiteSchemes from './Website/WebsiteSchemes';
import GramPanchayatScheme from './Website/GramPanchayatScheme';
import OtherDepartmentSchemes from './Website/OtherDepartmentSchemes';
import Niyam from './Website/Niyam';
import Adhiniyam from './Website/Adhiniyam';
import Paripatrake from './Website/Paripatrake';
import Websitemnrega from './Website/Websitemnrega';
import WebsiteFooter from './Website/WebsiteFooter';
import WebsiteGallery from './Website/WebsiteGallery';
import ScrollToTop from './Website/ScrollToTop';
import PdfArjacheNamune from './Website/Pdfअर्जाचीनमुने';
import AhilyadeviForm from './Website/AhilyadeviForm';
import LoksevaArjForm from './Website/LoksevaArjForm';
import BebakiPramanpatraForm from './Website/BebakiPramanpatraForm';
import PherpharArjForm from './Website/PherpharArjForm';
import PdfNoticeNamune from './Website/Pdfनोटीसनमुने';
import PdfTharavNamune from './Website/Pdfठरावनमुने';
import PdfPrastavNamune from './Website/Pdfप्रस्तावनमुने';
import PdfItarNamune from './Website/Pdf इतरनमुने';
import PdfNamune from './Website/Pdfनमुने';
import NaharakatArjForm from './Website/NaharakatArjForm';
import NalJodaniArjForm from './Website/NalJodaniArjForm';
import Namuna8SanyuktArjForm from './Website/Namuna8SanyuktArjForm';
import NavratrotsavNocForm from './Website/NavratrotsavNocForm';
import GaneshUtsavNocForm from './Website/GaneshUtsavNocForm';
import JanmMrutyuAnuplabdhataForm from './Website/JanmMrutyuAnuplabdhataForm';
import JanmMrutyuNondvahiAnuplabdhataForm from './Website/JanmMrutyuNondvahiAnuplabdhataForm';
import NavratrotsavNocForm2024 from './Website/NavratrotsavNocForm2024';
import BandhkamParvana150sqmForm from './Website/BandhkamParvana150sqmForm';
import DhvajarohanSuchana26Jan2026Form from './Website/DhvajarohanSuchana26Jan2026Form';
import GramsabhaNoticeAacharsanhitaForm from './Website/GramsabhaNoticeAacharsanhitaForm';
import GramsabhaNoticeAacharsanhitaWordForm from './Website/GramsabhaNoticeAacharsanhitaWordForm';
import GramsabhaNoticeNoAacharsanhitaWordForm from './Website/GramsabhaNoticeNoAacharsanhitaWordForm';
import GramsabhaNoticeNoAacharsanhitaPdfForm from './Website/GramsabhaNoticeNoAacharsanhitaPdfForm';
import SpecialGramsabhaNotice26Dec2025Form from './Website/SpecialGramsabhaNotice26Dec2025Form';
import PlasticBanResolutionForm from './Website/PlasticBanResolutionForm';
import VbGramResolutionForm from './Website/VbGramResolutionForm';
import VbGramWordResolutionForm from './Website/VbGramWordResolutionForm';
import TaxDiscountResolutionForm from './Website/TaxDiscountResolutionForm';
import MukhyaMantriAbhiyanResolutionForm from './Website/MukhyaMantriAbhiyanResolutionForm';
import PdfPramanpatraNamune from './Website/pdfप्रमाणपत्रनमुने';
import PherAakaraniPanchnamaForm from './Website/PherAakaraniPanchnamaForm';
import Dhvajarohan26JanForm from './Website/Dhvajarohan26JanForm';
import QrCodeAppDownloadForm from './Website/QrCodeAppDownloadForm';
import KrushiKarjMitraShifaraspatsaForm from './Website/KrushiKarjMitraShifaraspatsaForm';


import FinanceCommissionForm from './Website/FinanceCommissionForm';
import OtherSchemesForm from './Website/OtherSchemesForm';
import MeetingNoticeForm from './Website/MeetingNoticeForm';
import ResolutionForm from './Website/ResolutionForm';
import LetterForm from './Website/LetterForm';
import TaxDemandBill from './Website/TaxDemandBill';
import DemandNoteForm from './Website/DemandNoteForm';
import SeizureWarrantForm from './Website/SeizureWarrantForm';
import EncroachmentNoticeForm from './Website/EncroachmentNoticeForm';
import NoticesAndOtherDashboard from './Component2/Asthapan/NoticesAndOtherDashboard';

import SelfDeclarationDashboard from './Component2/Asthapan/SelfDeclarationDashboard';
import PdfNamuneDashboard from './Component2/Asthapan/PdfNamuneDashboard';

import ResidentialDeclarationForm from './Website/ResidentialDeclarationForm';
import ElectricityDeclarationForm from './Website/ElectricityDeclarationForm';
import NoBenefitDeclarationForm from './Website/NoBenefitDeclarationForm';
import AliveDeclarationForm from './Website/AliveDeclarationForm';
import ToiletDeclarationForm from './Website/ToiletDeclarationForm';
import WidowDeclarationForm from './Website/WidowDeclarationForm';









// Clerk Components
import Dashboard from './users/pages/Dashboard';
import Dashboard2 from './users/pages/Dashboard2';
import Component2Gramniddhidetails from './Component2/Gramniddhi/GramniddhiDetails'
import Component2Milakhatnondani from './Component2/Gramniddhi/Milakhatnondani'
import Component2Newmilakhatregister from './Component2/Gramniddhi/Newmilakhatregister'
import Component2Namuna8Report from './Component2/Gramniddhi/Namuna8Report'
import Component2Namuna9Report from './Component2/Gramniddhi/Namuna9Report'
import Component2TaxBillReport from './Component2/Gramniddhi/TaxBillReport'
import Component2Grampanchatnivaad from './Component2/Gramniddhi/Grampanchayatnivaad'
import Component2TaxReceipt from './Component2/Gramniddhi/TaxReceipt';
import Component2Karpavthi from './Component2/Gramniddhi/Karpavthi'
import Component2TaxCollectionFrom from './Component2/Gramniddhi/TaxCollectionForm';
import Component2Readyrekaran from './Component2/Gramniddhi/Readyrekaran'
import Componemt2Vardname from './Component2/Gramniddhi/Vardname'
import AsthapanDashboard from './Component2/Asthapan/AsthapanDashboard';
import AdhikDakhleDashboard from './Component2/Asthapan/AdhikDakhleDashboard';
import GrampanchayatAsthapan from './Component2/Asthapan/GrampanchayatAsthapan';
import DakhlUtareFeeReport from './Component2/Asthapan/DakhlUtareFeeReport';
import AsthapanNamuna7Receipt from './Component2/Asthapan/Namuna7Receipt';
import DakhlUtarePrintReport from './Component2/Asthapan/DakhlUtarePrintReport';
import SangynaAaniSanket from './Component2/Asthapan/SangynaAaniSanket';
import WardMahiti from './Component2/Asthapan/WardMahiti';
import TaxSystem from './Component2/Asthapan/TaxSystem';
import TaxType from './Component2/Asthapan/TaxType';
import ReadyreckonerType from './Component2/Asthapan/ReadyreckonerType';
import ReadyreckonerRates from './Component2/Asthapan/ReadyreckonerRates';
import Certificates from './Component2/Asthapan/Certificates';
import AtikramanNotice from './Component2/Asthapan/AtikramanNotice';
import IncomeCertificate from './Component2/Asthapan/IncomeCertificate';
import ConstructionPermission from './Component2/Asthapan/ConstructionPermission';
import NoDuesCertificate from './Component2/Asthapan/NoDuesCertificate';
import BPLCertificate from './Component2/Asthapan/BPLCertificate';
import WaterConnection from './Component2/Asthapan/WaterConnection';
import NoObjectionCertificate from './Component2/Asthapan/NoObjectionCertificate';
import ConstructionPermissionApp from './Component2/Asthapan/ConstructionPermissionApp';
import ResidentCertificate from './Component2/Asthapan/ResidentCertificate';
import BenefitNotAvailedCertificate from './Component2/Asthapan/BenefitNotAvailedCertificate';
import ElectricityCertificate from './Component2/Asthapan/ElectricityCertificate';
import Registrations from './Component2/Asthapan/Registrations';
import BirthRegistration from './Component2/Asthapan/BirthRegistration';
import DeathRegistration from './Component2/Asthapan/DeathRegistration';
import MarriageRegistration from './Component2/Asthapan/MarriageRegistration';
import PanipuravthaDashboard from './Component2/Panipuravtha/PanipuravthaDashboard';
import PermanentInfo from './Component2/Panipuravtha/PermanentInfo';
import AccountInfoDashboard from './Component2/Panipuravtha/AccountInfoDashboard';
import AccountGroup from './Component2/Panipuravtha/AccountGroup';
import AccountDetails from './Component2/Panipuravtha/AccountDetails';
import BudgetSheet from './Component2/Panipuravtha/BudgetSheet';
import EmployeeInfo from './Component2/Panipuravtha/EmployeeInfo';
import Namuna1Info from './Component2/Panipuravtha/Namuna1Info';
import Namuna2Info from './Component2/Panipuravtha/Namuna2Info';
import PanipuravthaTransactions from './Component2/Panipuravtha/PanipuravthaTransactions';
import OtherTransactionsPage from './Component2/Panipuravtha/OtherTransactions';
import Namuna17Report from './Component2/Panipuravtha/Namuna17Report';
import PanipuravthaReportDashboard from './Component2/Panipuravtha/PanipuravthaReportDashboard';
import Namuna9Report from './Component2/Panipuravtha/Namuna9Report';
import Namuna9KReport from './Component2/Panipuravtha/Namuna9KReport';
import Namuna10Report from './Component2/Panipuravtha/Namuna10Report';
import CollectionPotkirdReport from './Component2/Panipuravtha/CollectionPotkirdReport';
import TaxNoticeReport from './Component2/Panipuravtha/TaxNoticeReport';
import ThakbakidarReport from './Component2/Panipuravtha/ThakbakidarReport';
import CourtNoticeReport from './Component2/Panipuravtha/CourtNoticeReport';
import PanipuravthaInfoService from './Component2/Panipuravtha/PanipuravthaInfoService';
import TaxInfoDashboard from './Component2/Panipuravtha/TaxInfoDashboard';
import TaxDemandReport from './Component2/Panipuravtha/TaxDemandReport';
import TaxDemandPrintReport from './Component2/Panipuravtha/TaxDemandPrintReport';
import TaxCollectionReport from './Component2/Panipuravtha/TaxCollectionReport';
import TaxCollectionPrintReport from './Component2/Panipuravtha/TaxCollectionPrintReport';
import TaxOutstandingReport from './Component2/Panipuravtha/TaxOutstandingReport';
import TaxOutstandingPrintReport from './Component2/Panipuravtha/TaxOutstandingPrintReport';
import MasikKarVasuliReport from './Component2/Panipuravtha/MasikKarVasuliReport';
import MasikKarVasuliPrint from './Component2/Panipuravtha/MasikKarVasuliPrint';
import PanipuravthaArthikReportDashboard from './Component2/Panipuravtha/PanipuravthaArthikReportDashboard';
import PanipuravthaNamuna1Report from './Component2/Panipuravtha/PanipuravthaNamuna1Report';
import PanipuravthaNamuna2Report from './Component2/Panipuravtha/PanipuravthaNamuna2Report';
import PanipuravthaNamuna3Report from './Component2/Panipuravtha/PanipuravthaNamuna3Report';
import PanipuravthaNamuna1Print from './Component2/Panipuravtha/PanipuravthaNamuna1Print';
import Namuna7Receipt from './Component2/Panipuravtha/Namuna7Receipt';
import LoanDepositDashboard from './Component2/Panipuravtha/LoanDepositDashboard';
import LoanManagement from './Component2/Panipuravtha/LoanManagement';
import DepositManagement from './Component2/Panipuravtha/DepositManagement';
import StockDeadstockDashboard from './Component2/Panipuravtha/StockDeadstockDashboard';
import StockList from './Component2/Panipuravtha/StockList';
import SupplierList from './Component2/Panipuravtha/SupplierList';
import StockPurchase from './Component2/Panipuravtha/StockPurchase';
import DeadstockPurchase from './Component2/Panipuravtha/DeadstockPurchase';
import StockDistribution from './Component2/Panipuravtha/StockDistribution';
import DeadstockDisposal from './Component2/Panipuravtha/DeadstockDisposal';
import MeasurementInfo from './Component2/Panipuravtha/MeasurementInfo';
import HSNInfo from './Component2/Panipuravtha/HSNInfo';
import EmployeeSalaryInfo from './Component2/Panipuravtha/EmployeeSalaryInfo';
import GramniddhiOtherTransactions from './Component2/Gramniddhi/OtherTransactions';
import ArthikReportDashboard from './Component2/Gramniddhi/ArthikReportDashboard';


import Component2Aarthikreport from './Component2/Gramniddhi/Aarthikreport';
import Component2Namuna1 from './Component2/Gramniddhi/Namuna1';
import Component2Aarthikreportnamuna2 from './Component2/Gramniddhi/Aarthikreportnamuna2';
import Component2Aarthikreportnamuna3 from './Component2/Gramniddhi/Aarthikreportnamuna3';
import Component2Aarthikreportnamuna4 from './Component2/Gramniddhi/Aarthikreportnamuna4';
import Component2Aarthikreportnamuna5 from './Component2/Gramniddhi/Aarthikreportnamuna5';
import Component2Aarthikreportnamuna5k from './Component2/Gramniddhi/Aarthikreportnamuna5k';
import Component2Aarthikreportnamuna6 from './Component2/Gramniddhi/Aarthikreportnamuna6';
import Component2Aarthikreportnamuna7 from './Component2/Gramniddhi/Aarthikreportnamuna7';
import Component2Aarthikreportnamuna11 from './Component2/Gramniddhi/Aarthikreportnamuna11';
import Component2Aarthikreportnamuna12 from './Component2/Gramniddhi/Aarthikreportnamuna12';
import Component2Aarthikreportnamuna13 from './Component2/Gramniddhi/Aarthikreportnamuna13';
import Component2Aarthikreportnamuna14 from './Component2/Gramniddhi/Aarthikreportnamuna14';
import Component2Aarthikreportnamuna15 from './Component2/Gramniddhi/Aarthikreportnamuna15';
import Component2Report from './Component2/Gramniddhi/Report';
import Component2Reportnamuna8v from './Component2/Gramniddhi/Reportnamuna8v';




import AddProperty from './users/pages/Addproperty';
import PropertyList from './users/pages/PropertyList';
import TaxCalculation from './users/pages/Taxcalculation';
import PrintPDF from './users/pages/PrintPDF';
import TaxHistory from './users/pages/TaxHistory';
import Navbar from './users/components/Navbar';
import Sidebar from './users/components/Sidebar';
import GrampanchayatForm from './users/components/pages/form/GrampanchayatForm';
import Namuna7reciept from './Component2/Gramniddhi/Namuna7Receipt'
import Namuna8reciept from './Component2/Gramniddhi/Namuna8Report'
import Namuna9reciept from './Component2/Gramniddhi/Namuna9Report'
import Namuna12reciept from './Component2/Gramniddhi/Namuna12Receipt'


import AddNamuna9 from './users/components/namuna-9/AddNamuna9';
import Japti from './users/components/namuna-9/Japti';
import Magnipavti from './users/components/namuna-9/magnipavti';
import Namuna9List from './users/components/namuna-9/Namuna9List';
import Namuna9RegisterRpt from './users/components/namuna-9/Namuna9RegisterRpt';
import NoticeReport from './users/components/namuna-9/NoticeReport';


import AddNamuna7 from './users/components/numana7/BankMahiti';
import Namuna7Banktobanktransfer from './users/components/numana7/BankToBankTransfer'
import Namuna7Chequebookmahiti from './users/components/numana7/ChequeBookMahiti'
import Namuna7JamaKarnaryachiMahiti from './users/components/numana7/JamaKarnaryachiMahiti'
import Namuna7VarshikShillakForm from './users/components/numana7/VarshikShillakForm'


import Namuna10 from './users/components/namuna10/Namuna10'
import Component2OtherTransactions from './Component2/Gramniddhi/OtherTransactions';
import Rokhnave from './users/components/numana7/Rokhnave';
import Dhandeshjama from './users/components/numana7/Dhandeshjama';

// Admin Components
import AdminDashboard from './Admin/pages/AdminDashboard';
import AdminNavbar from './Admin/components/AdminNavbar';
import AdminSidebar from './Admin/components/AdminSidebar';
import GramPanchayatManagement from './Admin/pages/GramPanchayatManagement';
import ApplicationMonitoring from './Admin/pages/ApplicationMonitoring';
import FinancialMonitoring from './Admin/pages/FinancialMonitoring';
import UserManagement from './Admin/pages/UserManagement';
import Reports from './Admin/pages/Reports';
import Complaints from './Admin/pages/Complaints';
import AuditLogs from './Admin/pages/AuditLogs';
import Notifications from './Admin/pages/Notifications';
import Settings from './Admin/pages/Settings';


// Clerk Layout
function ClerkLayout() {
  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Clerk Sidebar */}
      <Sidebar isCollapsed={false} />

      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Clerk Navbar */}
        <Navbar />

        {/* Clerk Pages */}
        <main className="flex-1 overflow-auto p-6 bg-white">
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard2" element={<Dashboard2 />} />
            <Route path="/Milakhatnondani" element={<Component2Milakhatnondani />} />
            <Route path="/Newmilakhatregister" element={<Component2Newmilakhatregister />} />
            <Route path="/namuna8/:id" element={<Component2Namuna8Report />} />
            <Route path="/namuna9/:id" element={<Component2Namuna9Report />} />
            <Route path="/taxbill/:id" element={<Component2TaxBillReport />} />
            <Route path="/gramniddhidetails" element={<Component2Gramniddhidetails />} />
            <Route path="/grampanchayatnivaad" element={<Component2Grampanchatnivaad />} />
            <Route path="/tax-receipt" element={<Component2TaxReceipt />} />
            <Route path="/karpavthi" element={<Component2Karpavthi />} />
            <Route path="/taxcollectionform" element={<Component2TaxCollectionFrom />} />
            <Route path="/vardname" element={<Componemt2Vardname />} />
            <Route path="/readyrekaran" element={<Component2Readyrekaran />} />
            <Route path="/panipuravtha/dashboard" element={<PanipuravthaDashboard />} />
            <Route path="/panipuravtha/report" element={<PanipuravthaReportDashboard />} />
            <Route path="/panipuravtha/namuna-9" element={<Namuna9Report />} />
            <Route path="/panipuravtha/namuna-9k" element={<Namuna9KReport />} />
            <Route path="/panipuravtha/namuna-10" element={<Namuna10Report />} />
            <Route path="/panipuravtha/collection-potkird" element={<CollectionPotkirdReport />} />
            <Route path="/panipuravtha/tax-notice" element={<TaxNoticeReport />} />
            <Route path="/panipuravtha/thakbakidar" element={<ThakbakidarReport />} />
            <Route path="/panipuravtha/court-notice" element={<CourtNoticeReport />} />
            <Route path="/panipuravtha/info-service" element={<PanipuravthaInfoService />} />
            <Route path="/panipuravtha/tax-info" element={<TaxInfoDashboard />} />
            <Route path="/panipuravtha/tax-demand" element={<TaxDemandReport />} />
            <Route path="/panipuravtha/tax-collection" element={<TaxCollectionReport />} />
            <Route path="/panipuravtha/tax-outstanding" element={<TaxOutstandingReport />} />
            <Route path="/panipuravtha/monthly-report" element={<MasikKarVasuliReport />} />
            <Route path="/panipuravtha/financial-report" element={<PanipuravthaArthikReportDashboard />} />
            <Route path="/panipuravtha/financial-report/namuna-1" element={<PanipuravthaNamuna1Report />} />
            <Route path="/panipuravtha/financial-report/namuna-2" element={<PanipuravthaNamuna2Report />} />
            <Route path="/panipuravtha/financial-report/namuna-3" element={<PanipuravthaNamuna3Report />} />

            <Route path="/panipuravtha/account-group" element={<AccountGroup />} />
            <Route path="/asthapan-dashboard" element={<AsthapanDashboard />} />
            <Route path="/asthapan/adhik-dakhle" element={<AdhikDakhleDashboard />} />
            <Route path="/asthapan/grampanchayat" element={<GrampanchayatAsthapan />} />
            <Route path="/asthapan/grampanchayat/fee-report" element={<DakhlUtareFeeReport />} />
            <Route path="/asthapan/grampanchayat/receipt" element={<AsthapanNamuna7Receipt />} />
            <Route path="/asthapan/grampanchayat/sangyna-aani-sanket" element={<SangynaAaniSanket />} />
            <Route path="/asthapan/grampanchayat/ward-mahiti" element={<WardMahiti />} />
            <Route path="/asthapan/tax-system" element={<TaxSystem />} />
            <Route path="/asthapan/tax-type" element={<TaxType />} />
            <Route path="/asthapan/readyreckoner-type" element={<ReadyreckonerType />} />
            <Route path="/asthapan/readyreckoner-rates" element={<ReadyreckonerRates />} />
            <Route path="/asthapan/certificates" element={<Certificates />} />
            <Route path="/OtherTransactions" element={<GramniddhiOtherTransactions />} />


            <Route path="/aarthikreport" element={<Component2Aarthikreport />} />
            <Route path="/namuna1" element={<Component2Namuna1 />} />
            <Route path="/aarthikreportnamuna2" element={<Component2Aarthikreportnamuna2 />} />
            <Route path="/aarthikreportnamuna3" element={<Component2Aarthikreportnamuna3 />} />
            <Route path="/aarthikreportnamuna4" element={<Component2Aarthikreportnamuna4 />} />
            <Route path="/aarthikreportnamuna5" element={<Component2Aarthikreportnamuna5 />} />
            <Route path="/aarthikreportnamuna5k" element={<Component2Aarthikreportnamuna5k />} />
            <Route path="/aarthikreportnamuna6" element={<Component2Aarthikreportnamuna6 />} />
            <Route path="/aarthikreportnamuna7" element={<Component2Aarthikreportnamuna7 />} />
            <Route path="/aarthikreportnamuna11" element={<Component2Aarthikreportnamuna11 />} />
            <Route path="/aarthikreportnamuna12" element={<Component2Aarthikreportnamuna12 />} />
            <Route path="/aarthikreportnamuna13" element={<Component2Aarthikreportnamuna13 />} />
            <Route path="/aarthikreportnamuna14" element={<Component2Aarthikreportnamuna14 />} />
            <Route path="/aarthikreportnamuna15" element={<Component2Aarthikreportnamuna15 />} />
            <Route path="/report" element={<Component2Report />} />
            <Route path="/reportnamuna8v" element={<Component2Reportnamuna8v />} />



            <Route path="/asthapan/certificates/atikraman-notice" element={<AtikramanNotice />} />
            <Route path="/asthapan/certificates/income-certificate" element={<IncomeCertificate />} />
            <Route path="/asthapan/certificates/construction-permission" element={<ConstructionPermission />} />
            <Route path="/asthapan/certificates/no-dues-certificate" element={<NoDuesCertificate />} />
            <Route path="/asthapan/certificates/bpl-certificate" element={<BPLCertificate />} />
            <Route path="/asthapan/certificates/water-connection" element={<WaterConnection />} />
            <Route path="/asthapan/certificates/water-connection" element={<WaterConnection />} />
            <Route path="/asthapan/certificates/no-objection-certificate" element={<NoObjectionCertificate />} />
            <Route path="/asthapan/certificates/construction-permission-app" element={<ConstructionPermissionApp />} />
            <Route path="/asthapan/certificates/resident-certificate" element={<ResidentCertificate />} />
            <Route path="/asthapan/certificates/benefit-not-availed" element={<BenefitNotAvailedCertificate />} />
            <Route path="/asthapan/certificates/electricity-certificate" element={<ElectricityCertificate />} />
            <Route path="/asthapan/registrations" element={<Registrations />} />
            <Route path="/asthapan/registrations/birth" element={<BirthRegistration />} />
            <Route path="/asthapan/registrations/death" element={<DeathRegistration />} />
            <Route path="/asthapan/registrations/marriage" element={<MarriageRegistration />} />

            <Route path="/panipuravtha-dashboard" element={<PanipuravthaDashboard />} />
            <Route path="/arthik-report" element={<ArthikReportDashboard />} />
            <Route path="/panipuravtha/permanent-info" element={<PermanentInfo />} />
            <Route path="/panipuravtha/permanent-info/account-info" element={<AccountInfoDashboard />} />
            <Route path="/panipuravtha/permanent-info/account-info/group" element={<AccountGroup />} />
            <Route path="/panipuravtha/permanent-info/account-info/details" element={<AccountDetails />} />
            <Route path="/panipuravtha/permanent-info/budget" element={<BudgetSheet />} />
            <Route path="/panipuravtha/permanent-info/employee-info" element={<EmployeeInfo />} />
            <Route path="/panipuravtha/permanent-info/form-1" element={<Namuna1Info />} />
            <Route path="/panipuravtha/permanent-info/form-2" element={<Namuna2Info />} />
            <Route path="/panipuravtha/transactions" element={<PanipuravthaTransactions />} />
            <Route path="/panipuravtha/transactions/other" element={<OtherTransactionsPage />} />
            <Route path="/panipuravtha/print/namuna7/:id" element={<Namuna7Receipt />} />
            <Route path="/panipuravtha/transactions/loan-deposit" element={<LoanDepositDashboard />} />
            <Route path="/panipuravtha/transactions/loan" element={<LoanManagement />} />
            <Route path="/panipuravtha/transactions/deposit" element={<DepositManagement />} />
            <Route path="/panipuravtha/transactions/stock-deadstock" element={<StockDeadstockDashboard />} />
            <Route path="/panipuravtha/transactions/stock/list" element={<StockList />} />
            <Route path="/panipuravtha/transactions/stock/suppliers" element={<SupplierList />} />
            <Route path="/panipuravtha/transactions/stock/purchase" element={<StockPurchase />} />
            <Route path="/panipuravtha/transactions/stock/deadstock-purchase" element={<DeadstockPurchase />} />
            <Route path="/panipuravtha/transactions/stock/distribution" element={<StockDistribution />} />
            <Route path="/panipuravtha/transactions/deadstock/disposal" element={<DeadstockDisposal />} />
            <Route path="/panipuravtha/transactions/stock/measurement" element={<MeasurementInfo />} />
            <Route path="/panipuravtha/transactions/stock/hsn" element={<HSNInfo />} />
            <Route path="/panipuravtha/transactions/salary-info" element={<EmployeeSalaryInfo />} />
            <Route path="/finance-commission" element={<FinanceCommissionForm />} />
          <Route path="/other-schemes" element={<OtherSchemesForm />} />
          <Route path="/meeting-notice" element={<MeetingNoticeForm />} />
          <Route path="/prepare-resolution" element={<ResolutionForm />} />
          <Route path="/prepare-letter" element={<LetterForm />} />
          <Route path="/tax-demand-bill" element={<TaxDemandBill />} />
          <Route path="/demand-note" element={<DemandNoteForm />} />
          <Route path="/seizure-warrant" element={<SeizureWarrantForm />} />
          <Route path="/encroachment-notice" element={<EncroachmentNoticeForm />} />
          <Route path="/notices-and-other-dashboard" element={<NoticesAndOtherDashboard />} />

                    <Route path="/self-declaration-dashboard" element={<SelfDeclarationDashboard />} />
                    <Route path="/pdf-namune" element={<PdfNamuneDashboard />} />
                    <Route path="/pdf-namune/forms" element={<PdfArjacheNamune />} />
                    <Route path="/pdf-namune/pramanpatra-namune" element={<PdfPramanpatraNamune />} />
                    <Route path="/pdf-namune/notices" element={<PdfNoticeNamune />} />
                    <Route path="/pdf-namune/resolutions" element={<PdfTharavNamune />} />
                    <Route path="/pdf-namune/proposals" element={<PdfPrastavNamune />} />
                    <Route path="/pdf-namune/other-forms" element={<PdfItarNamune />} />
                    <Route path="/pdf-namune/namune" element={<PdfNamune />} />
            <Route path="/self-declaration/residential" element={<ResidentialDeclarationForm />} />
            <Route path="/self-declaration/electricity" element={<ElectricityDeclarationForm />} />
            <Route path="/self-declaration/no-benefit" element={<NoBenefitDeclarationForm />} />
            <Route path="/self-declaration/alive" element={<AliveDeclarationForm />} />
            <Route path="/self-declaration/toilet" element={<ToiletDeclarationForm />} />
            <Route path="/self-declaration/widow" element={<WidowDeclarationForm />} />




            <Route path="/add-property" element={<AddProperty />} />
            <Route path="/property-list" element={<PropertyList />} />
            <Route path="/calculate-tax" element={<TaxCalculation />} />
            <Route path="/print-pdf" element={<PrintPDF />} />
            <Route path="/tax-history" element={<TaxHistory />} />
            {/* <Route path="/bankaccountform" element={<BankAccountForm/>} /> */}


            <Route path='/addnamuna9' element={<AddNamuna9 />} />
            <Route path='/japti' element={<Japti />} />
            <Route path='/magnipavti' element={<Magnipavti />} />
            <Route path='/namuna9list' element={<Namuna9List />} />
            <Route path='/namuna9register-rpt' element={<Namuna9RegisterRpt />} />
            <Route path='/notice-report' element={<NoticeReport />} />

            <Route path='/BankMahiti' element={<AddNamuna7 />} />
            <Route path='/BankToBankTransfer' element={<Namuna7Banktobanktransfer />} />
            <Route path='/ChequeBookMahiti' element={<Namuna7Chequebookmahiti />} />
            <Route path='/VarshikShillakForm' element={<Namuna7VarshikShillakForm />} />
            <Route path='/JamaKarnaryachiMahiti' element={<Namuna7JamaKarnaryachiMahiti />} />

            <Route path='/Namuna10' element={<Namuna10 />} />
            <Route path='/Namuna12Receipt' element={<Namuna12reciept />} />
            <Route path='/Namuna8Receipt' element={<Namuna8reciept />} />
            <Route path='/Namuna9Receipt' element={<Namuna9reciept />} />
            <Route path='/Namuna7Receipt' element={<Namuna7reciept />} />
            <Route path="/othertransactions" element={<Component2OtherTransactions />} />
            <Route path='/Rokhnave' element={<Rokhnave />} />
            <Route path='/Dhandeshjama' element={<Dhandeshjama />} />


            {/* Default redirect for clerk */}
            <Route path="/" element={<Navigate to="/asthapan-dashboard" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

// Admin Layout
function AdminLayout() {
  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Admin Sidebar */}
      <AdminSidebar isCollapsed={false} />

      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Admin Navbar */}
        <AdminNavbar />

        {/* Admin Pages */}
        <main className="flex-1 overflow-auto p-6 bg-white">
          <Routes>
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/gram-panchayat" element={<GramPanchayatManagement />} />
            <Route path="/admin/applications" element={<ApplicationMonitoring />} />
            <Route path="/admin/financial" element={<FinancialMonitoring />} />
            <Route path="/admin/users" element={<UserManagement />} />
            <Route path="/admin/reports" element={<Reports />} />
            <Route path="/admin/complaints" element={<Complaints />} />
            <Route path="/admin/audit-logs" element={<AuditLogs />} />
            <Route path="/admin/notifications" element={<Notifications />} />
            <Route path="/admin/settings" element={<Settings />} />

            {/* Default redirect for admin */}
            <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}



// Protected Route Wrapper
function ProtectedRoute({ children }) {
  const userRole = localStorage.getItem('userRole');

  if (!userRole) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

// Main App
function App() {
  const userRole = localStorage.getItem('userRole');

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Public Website */}
        <Route
          path="/"
          element={
            <>
              <WebsiteNavbar />
              <WebsiteHome />
              <WebsiteFooter />
            </>
          }
        />
        <Route path="/certificate-selection" element={<><WebsiteNavbar /><CertificateSelection /> <WebsiteFooter /></>} />
        <Route path="/Birthcertificate" element={<><WebsiteNavbar /><Birthcertificate /> <WebsiteFooter /></>} />
        <Route path="/deathcertificate" element={<><WebsiteNavbar /><Deathcertificate /> <WebsiteFooter /></>} />
        <Route path="/Requestmarriage" element={<><WebsiteNavbar /><Requestmarriage /> <WebsiteFooter /></>} />
        <Route path="/Properstandard" element={<><WebsiteNavbar /><Properstandard /> <WebsiteFooter /></>} />
        <Route path="/Demancertificate" element={<><WebsiteNavbar /><Demandcertificate /> <WebsiteFooter /></>} />
        <Route path="/Certificatedestitute" element={<><WebsiteNavbar /><Certificatedestitute /> <WebsiteFooter /></>} />
        <Route path="/Housetax" element={<><WebsiteNavbar /><Housetax /> <WebsiteFooter /></>} />
        <Route path="/Paywatertax" element={<><WebsiteNavbar /><Paywatertax /> <WebsiteFooter /></>} />
        <Route path="/Womengroup" element={<><WebsiteNavbar /><Womengroup /> <WebsiteFooter /></>} />
        <Route path="/GramPanchayatInfo" element={<><WebsiteNavbar /><GramPanchayatInfo /> <WebsiteFooter /></>} />
        <Route path="/GramPanchayatSamiti" element={<><WebsiteNavbar /><GramPanchayatSamiti /> <WebsiteFooter /></>} />
        <Route path="/schemes" element={<><WebsiteNavbar /><WebsiteSchemes /> <WebsiteFooter /></>} />
        <Route path="/gram-panchayat-schemes" element={<><WebsiteNavbar /><GramPanchayatScheme /> <WebsiteFooter /></>} />
        <Route path="/other-department-schemes" element={<><WebsiteNavbar /><OtherDepartmentSchemes /> <WebsiteFooter /></>} />
        <Route path="/niyam" element={<><WebsiteNavbar /><Niyam /> <WebsiteFooter /></>} />
        <Route path="/adhiniyam" element={<><WebsiteNavbar /><Adhiniyam /> <WebsiteFooter /></>} />
        <Route path="/paripatrake" element={<><WebsiteNavbar /><Paripatrake /> <WebsiteFooter /></>} />
        <Route path="/Mnrega" element={<><WebsiteNavbar /><Websitemnrega /> <WebsiteFooter /></>} />
        <Route path="/gallery" element={<><WebsiteNavbar /><WebsiteGallery /> <WebsiteFooter /></>} />
        <Route path="/forms" element={<><WebsiteNavbar /><PdfArjacheNamune /> <WebsiteFooter /></>} />
        <Route path="/notices" element={<><WebsiteNavbar /><PdfNoticeNamune /> <WebsiteFooter /></>} />
        <Route path="/resolutions" element={<><WebsiteNavbar /><PdfTharavNamune /> <WebsiteFooter /></>} />
        <Route path="/proposals" element={<><WebsiteNavbar /><PdfPrastavNamune /> <WebsiteFooter /></>} />
        <Route path="/other-forms" element={<><WebsiteNavbar /><PdfItarNamune /> <WebsiteFooter /></>} />
        <Route path="/namune" element={<><WebsiteNavbar /><PdfNamune /> <WebsiteFooter /></>} />
        <Route path="/pramanpatra-namune" element={<><WebsiteNavbar /><PdfPramanpatraNamune /> <WebsiteFooter /></>} />
        
        {/* Public Self Declaration Routes */}
        <Route path="/residential" element={<><WebsiteNavbar /><ResidentialDeclarationForm /> <WebsiteFooter /></>} />
        <Route path="/electricity" element={<><WebsiteNavbar /><ElectricityDeclarationForm /> <WebsiteFooter /></>} />
        <Route path="/no-benefit" element={<><WebsiteNavbar /><NoBenefitDeclarationForm /> <WebsiteFooter /></>} />
        <Route path="/alive" element={<><WebsiteNavbar /><AliveDeclarationForm /> <WebsiteFooter /></>} />
        <Route path="/toilet" element={<><WebsiteNavbar /><ToiletDeclarationForm /> <WebsiteFooter /></>} />
        <Route path="/widow" element={<><WebsiteNavbar /><WidowDeclarationForm /> <WebsiteFooter /></>} />
        <Route path="/pramanpatra-namune" element={<><WebsiteNavbar /><PdfPramanpatraNamune /> <WebsiteFooter /></>} />
        <Route path="/ahilyadevi-form" element={<AhilyadeviForm />} />
        <Route path="/lokseva-arj-form" element={<LoksevaArjForm />} />
        <Route path="/bebaki-pramanpatra-form" element={<BebakiPramanpatraForm />} />
        <Route path="/pherphar-arj-form" element={<PherpharArjForm />} />
        <Route path="/naharakat-arj-form" element={<NaharakatArjForm />} />
        <Route path="/nal-jodani-arj-form" element={<NalJodaniArjForm />} />
        <Route path="/namuna8-sanyukt-arj-form" element={<Namuna8SanyuktArjForm />} />
        <Route path="/navratrotsav-noc-form" element={<NavratrotsavNocForm />} />
        <Route path="/ganesh-utsav-noc-form" element={<GaneshUtsavNocForm />} />
        <Route path="/janm-mrutyu-anuplabdhata-form" element={<JanmMrutyuAnuplabdhataForm />} />
        <Route path="/janm-mrutyu-nondvahi-anuplabdhata-form" element={<JanmMrutyuNondvahiAnuplabdhataForm />} />
        <Route path="/navratrotsav-noc-form-2024" element={<NavratrotsavNocForm2024 />} />
        <Route path="/bandhkam-parvana-150sqm-form" element={<BandhkamParvana150sqmForm />} />
        <Route path="/dhvajarohan-suchana-26jan2026-form" element={<DhvajarohanSuchana26Jan2026Form />} />
        <Route path="/gramsabha-notice-aacharsanhita-form" element={<GramsabhaNoticeAacharsanhitaForm />} />
        <Route path="/gramsabha-notice-aacharsanhita-word-form" element={<GramsabhaNoticeAacharsanhitaWordForm />} />
        <Route path="/gramsabha-notice-no-aacharsanhita-word-form" element={<GramsabhaNoticeNoAacharsanhitaWordForm />} />
        <Route path="/gramsabha-notice-no-aacharsanhita-pdf-form" element={<GramsabhaNoticeNoAacharsanhitaPdfForm />} />
        <Route path="/special-gramsabha-notice-26dec2025-form" element={<SpecialGramsabhaNotice26Dec2025Form />} />
        <Route path="/plastic-ban-resolution-form" element={<PlasticBanResolutionForm />} />
        <Route path="/vb-gram-resolution-form" element={<VbGramResolutionForm />} />
        <Route path="/vb-gram-word-resolution-form" element={<VbGramWordResolutionForm />} />
        <Route path="/tax-discount-resolution-form" element={<TaxDiscountResolutionForm />} />
        <Route path="/mukhyamantri-abhiyan-resolution-form" element={<MukhyaMantriAbhiyanResolutionForm />} />
        <Route path="/pher-aakarani-panchnama-form" element={<PherAakaraniPanchnamaForm />} />
        <Route path="/dhvajarohan-26jan-form" element={<Dhvajarohan26JanForm />} />
        <Route path="/qr-code-app-download-form" element={<QrCodeAppDownloadForm />} />
        <Route path="/krushi-karj-mitra-shifaraspatsa-form" element={<KrushiKarjMitraShifaraspatsaForm />} />
        {/* Login Page */}
        <Route
          path="/login"
          element={!userRole ? <Login /> : <Navigate to={userRole === 'admin' ? '/admin/dashboard' : '/dashboard'} replace />}
        />

        {/* Print Routes */}
        <Route
          path="/asthapan/grampanchayat/receipt"
          element={
            <ProtectedRoute>
              <AsthapanNamuna7Receipt />
            </ProtectedRoute>
          }
        />
        <Route
          path="/asthapan/grampanchayat/print-report"
          element={
            <ProtectedRoute>
              <DakhlUtarePrintReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/panipuravtha/tax-demand/print"
          element={
            <ProtectedRoute>
              <TaxDemandPrintReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/panipuravtha/tax-collection/print"
          element={
            <ProtectedRoute>
              <TaxCollectionPrintReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/panipuravtha/tax-outstanding/print"
          element={
            <ProtectedRoute>
              <TaxOutstandingPrintReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/panipuravtha/monthly-report/print"
          element={
            <ProtectedRoute>
              <MasikKarVasuliPrint />
            </ProtectedRoute>
          }
        />

        <Route
          path="/panipuravtha/financial-report/namuna-1/print"
          element={
            <ProtectedRoute>
              <PanipuravthaNamuna1Print />
            </ProtectedRoute>
          }
        />

        {/* App Routes (Clerk/Admin) */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              {userRole === 'clerk' ? <ClerkLayout /> : userRole === 'admin' ? <AdminLayout /> : <Navigate to="/login" replace />}
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;